<template>
  <div class="uc-page">
    <nav-bar @open-auth="onOpenAuth" />
    <pay-test-modal ref="payTestModal" />

    <div class="uc-body g-container">
      <aside class="uc-side">
        <div class="uc-user">
          <img :src="avatar" class="avatar" alt="" />
          <div class="info">
            <strong>{{ nickName || '未登录用户' }}</strong>
            <span class="g-tag" :class="stateClass">{{ stateText }}</span>
          </div>
        </div>

        <nav class="uc-nav">
          <button
            v-for="t in tabs"
            :key="t.key"
            :class="['nav-item', activeTab === t.key && 'is-active']"
            @click="switchTab(t.key)"
          >
            <i :class="['ico', t.icon]"></i>
            <span>{{ t.label }}</span>
            <em v-if="t.badge" class="badge">{{ t.badge }}</em>
          </button>
        </nav>

        <div class="uc-contact">
          <p>专属客户经理</p>
          <strong>蒋经理 19179363419</strong>
        </div>
      </aside>

      <main class="uc-main">
        <div class="uc-head">
          <h2>{{ currentTab.label }}</h2>
          <p>{{ currentTab.desc }}</p>
        </div>

        <div v-show="activeTab === 'basic'" class="uc-pane">
          <div v-if="coList.length" class="co-tabs">
            <button
              v-for="co in coList"
              :key="co.id"
              :class="['co-tab', activeCoId === co.id && 'is-active']"
              @click="switchCo(co.id)"
            >
              {{ co.coName }}
            </button>
            <button class="g-btn g-btn-default co-add" @click="addNewCo">+ 新增企业</button>
          </div>
          <co-edit-form
            v-if="activeCoId || editing"
            :key="formKey"
            :initial-form="form"
            @saved="onCoSaved"
            @unbind="onUnbind"
          />
          <div v-else class="uc-empty">
            <img src="@/assets/noData.png" />
            <p>暂无企业认证信息</p>
            <button class="g-btn g-btn-primary" @click="addNewCo">立即认证</button>
          </div>
        </div>

        <div v-show="activeTab === 'order'" class="uc-pane">
          <order-list @open-pay="onOpenPay" />
        </div>

        <div v-show="activeTab === 'bill'" class="uc-pane">
          <bill-list />
        </div>
      </main>
    </div>

    <unbind-modal ref="unbindModal" :co-id="form.id" @success="onUnbindSuccess" />
    <auth-modal ref="authModal" />
    <site-footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar'
import AuthModal from '@/components/AuthModal'
import SiteFooter from '@/components/SiteFooter'
import PayTestModal from '@/views/PayTestModal'
import CoEditForm from './usercenter/CoEditForm'
import OrderList from './usercenter/OrderList'
import BillList from './usercenter/BillList'
import UnbindModal from './usercenter/UnbindModal'
import { getCoList, getCoInfo } from '@/lib/api/attestation'

const TAB_MAP = {
  basic: { key: 'basic', label: '账号认证', desc: '完善企业资料后即可申请电子保函', icon: 'ico-shield' },
  order: { key: 'order', label: '我的订单', desc: '查看申请进度、出函状态，进行退保理赔', icon: 'ico-list' },
  bill:  { key: 'bill',  label: '我的发票', desc: '申请发票并跟踪开票进度', icon: 'ico-invoice' }
}

export default {
  name: 'UserCenter',
  components: {
    NavBar, AuthModal, SiteFooter, PayTestModal,
    CoEditForm, OrderList, BillList, UnbindModal
  },
  data () {
    return {
      activeTab: 'basic',
      activeCoId: '',
      coList: [],
      form: {},
      editing: false,
      formKey: 0,
      avatar: require('@/assets/head.png')
    }
  },
  computed: {
    tabs () {
      return Object.values(TAB_MAP)
    },
    currentTab () {
      return TAB_MAP[this.activeTab]
    },
    nickName () {
      return localStorage.getItem('nickName') || ''
    },
    stateText () {
      if (!this.form.state) return '未认证'
      if (Number(this.form.state) === 4) return '已认证'
      if (Number(this.form.state) === 1) return '审核中'
      return '未通过'
    },
    stateClass () {
      if (!this.form.state) return 'g-tag-info'
      const s = Number(this.form.state)
      if (s === 4) return 'g-tag-success'
      if (s === 1) return 'g-tag-primary'
      return 'g-tag-danger'
    }
  },
  watch: {
    '$route.query.tab' (t) {
      if (TAB_MAP[t]) this.activeTab = t
    }
  },
  created () {
    const t = this.$route.query.tab
    if (TAB_MAP[t]) this.activeTab = t
    this.loadCos()
  },
  methods: {
    onOpenAuth (type) { this.$refs.authModal.open(type) },
    switchTab (key) {
      this.activeTab = key
      this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, tab: key } })
    },
    loadCos () {
      const uid = localStorage.getItem('userId')
      if (!uid) return
      getCoList(uid).then((res) => {
        if (res.code === 200) {
          this.coList = res.data.list || []
          const id = res.data.id || (this.coList[0] && this.coList[0].id)
          if (id) this.switchCo(id)
          else this.editing = true
        }
      })
    },
    switchCo (id) {
      this.activeCoId = id
      this.editing = false
      getCoInfo(id).then((res) => {
        if (res.code === 200 && res.data && res.data.id) {
          this.form = { ...res.data }
        }
      })
      this.formKey++
    },
    addNewCo () {
      this.form = {}
      this.activeCoId = ''
      this.editing = true
      this.formKey++
    },
    onCoSaved () {
      this.loadCos()
    },
    onUnbind () {
      this.$refs.unbindModal.open('unbind', this.nickName)
    },
    onUnbindSuccess () {
      this.$confirm('是否继续绑定新手机号？', '提示', { type: 'warning' }).then(() => {
        this.$refs.unbindModal.open('bind')
      }).catch(() => {})
    },
    onOpenPay (data) {
      this.$refs.payTestModal.showModal('WX_NATIVE', data)
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variables.less';

.uc-page {
  min-height: 100vh;
  background: @bg-page;
}

.uc-body {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 24px;
  padding-top: 24px;
  padding-bottom: 48px;
}

.uc-side {
  background: #fff;
  border-radius: @radius-lg;
  padding: 24px 16px;
  height: fit-content;
  box-shadow: @shadow-sm;
}

.uc-user {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 4px 20px;
  border-bottom: 1px solid @border-light;

  .avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: @primary-soft;
  }
  .info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;

    strong {
      font-size: 14px;
      color: @text-strong;
      .ellipsis-mixin();
    }
  }
}

.uc-nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 12px 0;

  .nav-item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 10px;
    height: 42px;
    padding: 0 12px;
    border-radius: @radius-md;
    background: transparent;
    border: none;
    color: @text-secondary;
    font-size: 14px;
    cursor: pointer;
    text-align: left;
    transition: all @duration-fast @ease-out;

    .ico {
      width: 16px;
      height: 16px;
      background: @text-muted;
      border-radius: 4px;
    }

    &.is-active {
      background: @primary-soft;
      color: @primary;
      font-weight: 600;
      .ico { background: @primary; }
    }
    &:hover {
      color: @primary;
      background: @bg-soft;
    }

    .badge {
      position: absolute;
      right: 12px;
      min-width: 18px;
      height: 18px;
      padding: 0 5px;
      background: @danger;
      color: #fff;
      font-style: normal;
      font-size: 11px;
      border-radius: 9px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }
}

.uc-contact {
  margin-top: 24px;
  padding: 16px;
  background: @primary-soft;
  border-radius: @radius-md;

  p {
    margin: 0 0 6px;
    font-size: 12px;
    color: @text-secondary;
  }
  strong {
    color: @primary;
    font-size: 15px;
  }
}

.uc-main {
  min-height: 600px;
}

.uc-head {
  margin-bottom: 20px;

  h2 {
    margin: 0 0 4px;
    font-size: 22px;
    color: @text-strong;
    font-weight: 700;
  }
  p {
    margin: 0;
    color: @text-muted;
    font-size: 13px;
  }
}

.co-tabs {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  flex-wrap: wrap;

  .co-tab {
    height: 32px;
    padding: 0 18px;
    border-radius: @radius-full;
    background: #fff;
    border: 1px solid @border-base;
    color: @text-secondary;
    font-size: 13px;
    cursor: pointer;

    &.is-active {
      background: @primary;
      color: #fff;
      border-color: @primary;
    }
  }
  .co-add {
    height: 32px;
    padding: 0 14px;
    font-size: 12px;
  }
}

.uc-empty {
  background: #fff;
  border-radius: @radius-lg;
  padding: 60px 20px;
  text-align: center;

  img { width: 120px; opacity: .85; margin-bottom: 12px; }
  p { color: @text-muted; margin: 0 0 16px; }
}

.uc-pane { animation: fadeIn @duration-base @ease-out; }

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: none; }
}
</style>

